<template>
  <b-card class="mb-2 account-number-widget">
    <h4
      class="heading card-title title-slash"
      :class="!isTotalEqualsDdp ? 'mb-5' : ''"
    >
      {{ $t('dashboard.accountNumbers.title') }}
    </h4>
    <template v-if="!loading">
      <b-row>
        <b-col :lg="9" class="limit-col">
          <div class="limit-progress-container">
            <div
              class="text-right text-md-left"
              :class="
                isTotalEqualsDdp
                  ? 'total-limit-text-left'
                  : 'total-limit-text-right total-limit-mobile'
              "
            >
              <div class="total-limit-number">
                {{
                  exporterAnalytics.initial_credit_limit
                    | currency(null, null, currencyOptions.fractionCount)
                }}
              </div>
              <div class="total-limit-label">
                {{ $t('dashboard.accountNumbers.totalLimitLabel') }}
              </div>
            </div>
            <div
              class="limit-progress"
              :class="limitProgressColor"
              :style="`width: ${balanceProgressWidth * 100}%`"
            >
              <div :class="balanceProgressTextClass">
                <div class="limit-progress-number">
                  {{
                    exporterAnalytics.balance
                      | currency(null, null, currencyOptions.fractionCount)
                  }}
                </div>
                <div class="limit-progress-label">
                  {{ $t('dashboard.accountNumbers.progressLabel') }}
                </div>
              </div>
            </div>
            <div
              class="limit-progress ddp-limit-bar"
              :style="`width: ${ddpProgressWidth * 100}%`"
              v-if="!isTotalEqualsDdp"
            >
              <div :class="ddpProgressTextClass" class="box">
                <div class="limit-progress-number">
                  {{
                    exporterAnalytics.credit_limit
                      | currency(null, null, currencyOptions.fractionCount)
                  }}
                </div>
                <div class="limit-progress-label text">
                  {{ $t('dashboard.accountNumbers.ddpProgressLabel') }}
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col
          :lg="3"
          class="text-md-right d-flex justify-content-between"
          :class="!isTotalEqualsDdp ? 'mt-5 pt-4' : ''"
        >
          <div class="outstanding-mobile left">
            <div class="charges-label">
              {{ $t('dashboard.accountNumbers.outstandingLabel') }}
            </div>
            <div class="charges-number">
              {{
                exporterAnalytics.charges_outstanding
                  | currency(null, null, currencyOptions.fractionCount)
              }}
            </div>
          </div>
          <div class="outstanding-mobile right">
            <div class="charges-label">
              {{ $t('dashboard.accountNumbers.settlementLabel') }}
            </div>
            <div class="charges-number">
              {{
                exporterAnalytics.settlement_outstanding
                  | currency(null, null, currencyOptions.fractionCount)
              }}
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
    <loader v-else :height="105" />
  </b-card>
</template>
<script>
import Loader from '@/components/common/Loader'
import exportersService from '@/services/exporters'
import applicantService from '@/services/applicants'

export default {
  data() {
    return {
      loading: true,
      exporter: null,
      currencyOptions: {
        fractionCount: 0
      }
    }
  },
  mounted() {
    this.getAccountNumbers()
  },
  computed: {
    balanceProgressWidth() {
      if (
        !this.exporter ||
        parseInt(this.exporterAnalytics.initial_credit_limit > 0)
      ) {
        return 0
      } else {
        return (
          this.exporterAnalytics.balance /
          this.exporterAnalytics.initial_credit_limit
        )
      }
    },
    ddpProgressWidth() {
      if (
        !this.exporter ||
        parseInt(this.exporterAnalytics.initial_credit_limit > 0)
      ) {
        return 0
      } else {
        return (
          this.exporterAnalytics.credit_limit /
          this.exporterAnalytics.initial_credit_limit
        )
      }
    },
    limitProgressColor() {
      if (this.balanceProgressWidth < this.ddpProgressWidth) {
        return 'bg-primary'
      } else {
        return 'bg-danger'
      }
    },
    ddpProgressTextClass() {
      return this.ddpProgressWidth > 0.5
        ? 'limit-progress-text-left'
        : 'limit-progress-text-right'
    },
    balanceProgressTextClass() {
      return this.balanceProgressWidth > 0.5
        ? 'limit-progress-text-left'
        : 'limit-progress-text-right'
    },
    isTotalEqualsDdp() {
      return (
        this.exporterAnalytics.credit_limit ===
        this.exporterAnalytics.initial_credit_limit
      )
    },
    exporterAnalytics() {
      return (this.exporter && this.exporter.analytics) || {}
    }
  },
  methods: {
    increaseLimitRequest() {
      return this.$refs['request-modal'].show(this.increaseLimitNetworkRequest)
    },
    increaseLimitNetworkRequest() {
      return applicantService.addApplicant({
        applicant: {
          accountId: this.$store.state.account.accountId,
          request: 'Increase Overall Limit',
          channel: 'increase-limit-request'
        }
      })
    },
    getAccountNumbers() {
      if (this.$store.state.account.accountId) {
        return exportersService
          .fetchExporterMetaData(this.$store.state.account.accountId, {
            include: ['analytics', 'relationship_manager']
          })
          .then((res) => {
            this.loading = false
            this.exporter = res.data
            this.$emit('ddp', {
              utilized: res.data.analytics.balance,
              limit: res.data.analytics.credit_limit,
              rm: res.data.relationship_manager
            })
          })
          .catch((err) => {
            this.loading = false
            console.log(err)
          })
      }
    }
  },
  components: {
    Loader
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.account-number-widget {
  border: 1px solid $sky-blue;
  border-radius: 8px;
  box-shadow: none;
  .heading {
    color: $noble-blue-500;
    font-weight: 700;
  }
}
.limit-progress-container {
  border-radius: $border-radius 0 0 $border-radius;
  background: $gray-200;
  height: 1rem;
  position: relative;
  margin-top: 1rem;
  margin-bottom: 4rem;
}

.total-limit-text-left,
.total-limit-text-right,
.limit-progress-text-right,
.limit-progress-text-left {
  position: absolute;
  display: flex;
  color: $noble-blue-500;
  padding-right: 1rem;
  padding-left: 1rem;
}

.limit-progress-text-right,
.limit-progress-text-left {
  padding-top: 1rem;
  top: 0;
}

.limit-progress-text-right {
  border-left: 1px solid $gray-300;
  margin-right: -100%;
  left: 100%;
}

.limit-progress-text-left {
  right: 0;
  border-right: 1px solid $gray-300;
}

.total-limit-text-right {
  bottom: 0;
  left: 100%;
  border-left: 1px solid $gray-300;
  padding-left: 1rem;
  padding-bottom: 1rem;
}
.total-limit-text-left {
  bottom: 0;
  right: 0;
  border-right: 1px solid $gray-300;
  padding-right: 1rem;
  padding-bottom: 1rem;
}

.total-limit-number,
.limit-progress-number {
  font-weight: 300;
  font-size: 2.2rem;
  padding: 0 0.6rem;
}

.total-limit-label,
.limit-progress-label {
  padding-top: 0.8rem;
  text-transform: uppercase;
  font-size: 0.8rem;
  width: 5rem;
  line-height: 1;
}

.limit-progress {
  position: relative;
  border-radius: $border-radius 0 0 $border-radius;
  height: 100%;
  width: 50%;
  max-width: 100%;
}

.limit-col {
  padding-top: 1rem;
}

.charges-label {
  color: $noble-blue-500;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.charges-number {
  font-size: 1.4rem;
  color: $noble-blue-500;
}

.card-cta {
  margin-top: 1rem;
  border-top: 1px solid $gray-300;
  padding-top: 0.5rem;
}
.ddp-limit-bar {
  top: -1rem;
  .box {
    top: -4.25rem;
    .text {
      width: 7rem;
    }
  }
}
@include media-breakpoint-down(sm) {
  .account-number-widget {
    .limit-progress-text-right,
    .total-limit-text-left,
    .total-limit-text-right,
    .limit-progress-text-left {
      display: flex;
      flex-direction: column;
      .limit-progress-number,
      .total-limit-number {
        font-size: 1.25rem;
        padding: 0;
        white-space: nowrap;
        font-weight: 500;
      }
      .limit-progress-label,
      .total-limit-label {
        white-space: nowrap;
        width: auto;
        padding: 0.25rem 0;
      }
    }
    .limit-progress-text-left {
      padding-top: 1.5rem;
      .limit-progress-number {
        text-align: right;
      }
    }
    .limit-progress-text-right {
      padding-top: 1.5rem;
    }
    .total-limit-text-right,
    .total-limit-text-left {
      padding-bottom: 1.5rem;
    }
    .total-limit-mobile {
      right: 0;
      border-right: 1px solid $gray-300;
      border-left: 0;
      padding-top: 5rem;
      left: 0;
      bottom: -8rem;
      padding-bottom: 0;
    }
    .outstanding-mobile {
      display: flex;
      flex-direction: column-reverse;
      &.right {
        text-align: right;
        padding-left: 1rem;
      }
      .charges-number {
        font-size: 1.25rem;
      }
    }
    .limit-col {
      padding-bottom: 1rem;
    }
    .ddp-limit-bar {
      .box {
        padding-top: 0.5rem;
        padding-bottom: 0.6rem;
      }
    }
  }
}
</style>
